<i *ngIf="!this.salesDataService.Data" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
